import type { ViewspecState } from "../viewspecs/types.ts";
import { getActiveViewspecCodes } from "../viewspecs/codes.ts";

interface AddressBarProps {
  documentTitle: string;
  documentId: string;
  currentSID: string;
  viewspecs: ViewspecState;
}

export function AddressBar({
  documentTitle,
  documentId,
  currentSID,
  viewspecs,
}: AddressBarProps) {
  const codes = getActiveViewspecCodes(viewspecs);

  return (
    <div className="address-bar">
      <span>
        <span className="label">DOC:</span> {documentTitle}
      </span>
      <span>
        <span className="label">SID:</span> {currentSID || "—"}
      </span>
      <span>
        <span className="label">VIEW:</span> {codes}
      </span>
      {viewspecs.showFrozen && (
        <span style={{ color: "var(--nls-command)" }}>
          FROZEN@{viewspecs.showFrozen}
        </span>
      )}
      {viewspecs.filterText && (
        <span style={{ color: "var(--nls-command)" }}>
          FILTER:&quot;{viewspecs.filterText}&quot;
        </span>
      )}
    </div>
  );
}
